"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var BigpopupAction;
(function (BigpopupAction) {
    BigpopupAction.ON_SET_BIGPOPUP_ACTIVE = 'ON_SET_BIGPOPUP_ACTIVE';
    BigpopupAction.ON_SET_BIGPOPUP_MESSAGE = 'ON_SET_BIGPOPUP_MESSAGE';
    BigpopupAction.ON_SET_BIGPOPUP_MESSAGE_CLOSE = 'ON_SET_BIGPOPUP_MESSAGE_CLOSE';
    BigpopupAction.ON_SET_BIGPOPUP_ON_ACTION_CLICKED = 'ON_SET_BIGPOPUP_ON_ACTION_CLICKED';
    BigpopupAction.ON_BIGPOPUP_ENQUEUE = 'ON_BIGPOPUP_ENQUEUE';
    BigpopupAction.ON_BIGPOPUP_DEQUEUE = 'ON_BIGPOPUP_DEQUEUE';
    BigpopupAction.onSetActive = typesafe_actions_1.createAction(BigpopupAction.ON_SET_BIGPOPUP_ACTIVE, function (resolve) {
        return function (state) { return resolve(state); };
    });
    BigpopupAction.onSetMessage = typesafe_actions_1.createAction(BigpopupAction.ON_SET_BIGPOPUP_MESSAGE, function (resolve) {
        return function (messageInfo) { return resolve(messageInfo); };
    });
    BigpopupAction.messageClose = typesafe_actions_1.createAction(BigpopupAction.ON_SET_BIGPOPUP_MESSAGE_CLOSE, function (resolve) {
        return function () { return resolve(); };
    });
    BigpopupAction.onActionClicked = typesafe_actions_1.createAction(BigpopupAction.ON_SET_BIGPOPUP_ON_ACTION_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
    BigpopupAction.enqueue = typesafe_actions_1.createAction(BigpopupAction.ON_BIGPOPUP_ENQUEUE, function (resolve) {
        return function (message) { return resolve(message); };
    });
    BigpopupAction.dequeue = typesafe_actions_1.createAction(BigpopupAction.ON_BIGPOPUP_DEQUEUE, function (resolve) {
        return function () { return resolve(); };
    });
})(BigpopupAction || (BigpopupAction = {}));
exports.default = BigpopupAction;
